import React from 'react';
import { IonIcon, IonModal } from '@ionic/react';
import { close } from 'ionicons/icons';
import "./CannavacciuoloModalContentStyle.css";

export default function CannavacciuoloModal() {
    const [showModal, setShowModal] = React.useState(false);

    const onCloseHandler = () => setShowModal(false);

    React.useEffect(() => {
        setTimeout(() => setShowModal(true), 1200);
    }, [setShowModal]);

    return (
        <IonModal cssClass="cannavacciuolo-modal" mode="md" isOpen={showModal} onDidDismiss={onCloseHandler}>
            <IonIcon className="absolute top-2 left-2 text-black" size="large" icon={close} onClick={onCloseHandler}></IonIcon>
            <p className="mt-2 text-center text-xl text-[#193153] font-semibold">Scopri i nostri sponsor</p>
            <div className="flex flex-col justify-center">
                <img className="mt-6 mx-2" src="assets/cannavacciuolo/sponsor.png" />
                <img className="mt-6 mb-6 w-[70%] mx-auto" src="assets/cannavacciuolo/logo.png" />
            </div>
        </IonModal>
    );
}
